import { useRouter } from 'next/router';
import React from 'react';

import Button from '@/components/Button';
import HtmlHead from '@/components/Head';
import Typography from '@/components/Typography';
import LoginHelpCommonFrame from '@/components/recipe/loginHelp/CommonFrame';
import { Const } from '@/const';

const LoginHelpIndex = (): JSX.Element => {
  const router = useRouter();

  return (
    <>
      <HtmlHead />
      <LoginHelpCommonFrame title={`${Const.Action.login}できないときは`}>
        <Button
          color='primary'
          onClick={(): void => {
            router.push('/login_help/email');
          }}
        >
          メールアドレスが分からないとき
        </Button>
        <Button
          color='primary'
          onClick={(): void => {
            router.push('/login_help/password');
          }}
        >
          パスワードが分からないとき
        </Button>
        <Typography variant='dd' classes={['text-gray-500']}>
          *メールアドレスもパスワードも分からない方は、「メールアドレスが分からない」からお試しください。
        </Typography>
        <Button
          onClick={(): void => {
            router.push('/login');
          }}
        >
          {Const.Action.prev}
        </Button>
      </LoginHelpCommonFrame>
    </>
  );
};

export default LoginHelpIndex;
